import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { filter } from 'rxjs/operators';
import { GlobalComponent } from 'src/app/global/global.component';

@Component({
  selector: 'app-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent implements OnInit {
  isClient: Boolean
  LoginForm: FormGroup;
  page: string = 'login';
  type: string = 'client';
  agencyCode: string;
  currentUrl: string;
  linkStatus: string = "";
  currentUrlStringArray: any = [];
  AgencyCodeArray: any = [{
    agencyCode: 'AAAA'
  },
  {
    agencyCode: 'BBBB'
  },
  {
    agencyCode: 'beca'
  },
  ]
  @Output() newItemEvent = new EventEmitter<string>();

  constructor(private formBuilder: FormBuilder, public route: ActivatedRoute, public router: Router,
    public toasterService: ToastrService,
    public global: GlobalComponent, public http: HttpClient,) {
    this.LoginForm = this.formBuilder.group({
      Email: ['', Validators.required],
      WebPassword: ['', Validators.required],
      agencycode: ['', Validators.required],
    });

    router.events.pipe(filter(event => event instanceof NavigationEnd)
    ).subscribe(event => {

      let data: any = event;
      this.currentUrl = (data.url).toString();

      this.currentUrlStringArray = this.currentUrl.split('/', 3);

      if (this.currentUrlStringArray[2] == 'employee') {
        this.global.LoginTypeFields = 'employee'
        localStorage.setItem("fms_onboardtype", this.global.LoginTypeFields);
        this.global.OnboardType = "EMPLOYEE";
        localStorage.setItem("onboardLoginUser", this.global.OnboardType);

      }
      else if (this.currentUrlStringArray[2] == 'client') {
        this.global.OnboardType = "CLIENT";
        this.global.LoginTypeFields = 'client';
        localStorage.setItem("fms_onboardtype", this.global.LoginTypeFields);
        localStorage.setItem("onboardLoginUser", this.global.OnboardType);
      }
    });
  }

  ngOnInit(): void {

    this.global.fms_onboardagencycode = this.route.snapshot.paramMap.get('agencycode');
    localStorage.setItem("fms_onboardagencycode", this.global.fms_onboardagencycode);
    this.get();
  }

  get() {

    this.currentUrlStringArray = this.currentUrl.split('/', 4);
    let agencycode = this.currentUrlStringArray[3];
    let url = "api/Auth/GetAgencyDetailsForOtherusers?";
    let myparams = new URLSearchParams();
    if (agencycode == '' || agencycode == null || agencycode == "00000000-0000-0000-0000-000000000000") {
      myparams.append("agencyCode", agencycode);
    }
    else {
      myparams.append("agencyCode", agencycode);
    }
    this.global.portalAgencyCode = agencycode
    this.http.get(url + myparams).subscribe((data: any) => {
      if (data != null) {
        this.linkStatus = 'valid';
        this.global.agencyLogo = data.agencyLogo;
        this.global.agencyName = data.agencyName;
        this.global.agencyCode = agencycode;

        localStorage.setItem("fms_globalagencydetails", JSON.stringify(data));

        this.global.globalAgencyId = data.id
      }
    },
      (err: HttpErrorResponse) => {
        setTimeout(function () {
          this.linkStatus = 'invalid';
        }.bind(this), 1000)
        this.toasterService.error(err.error)
      })
  }

  MoveToNextPage(page: string) {
    this.page = page;
  }

  dataEmitfromChild(value) {
    this.page = value;
  }

}
